<div class="interventions-container">
  <div class="header">
    <div class="flex items-center">
      <i class="pi pi-calendar text-blue-400 mr-2 text-xl"></i>
      <h2 class="text-lg font-medium">Interventions</h2>
    </div>
    <div class="actions">
      <p-button
        label="Programmer une intervention"
        icon="pi pi-plus"
        (onClick)="onProgramClicked()"
        styleClass="p-button-success"
        [rounded]="true"
      >
      </p-button>
    </div>
  </div>

  @if (!interventions || interventions.length === 0) {
    <div class="empty-state">
      <i class="pi pi-calendar-times text-4xl mb-2 text-gray-500"></i>
      <span class="text-lg mb-3">Aucune intervention programmée</span>
      <p class="text-gray-500 text-center">
        Utilisez le bouton "Programmer" pour planifier une nouvelle
        intervention.
      </p>
    </div>
  } @else {
    <div class="interventions-timeline">
      @for (intervention of interventions; track intervention.id) {
        <div class="intervention-card">
          <div class="intervention-date">
            <div class="date-marker">
              <i class="pi pi-calendar"></i>
              {{ formatDate(intervention.startDate) }}
            </div>
            <div class="time-marker">
              {{ formatTime(intervention.startDate) }}
            </div>
          </div>
          <div class="intervention-content">
            <div class="intervention-header">
              <h3 class="intervention-title">{{ intervention.name }}</h3>
              <span
                class="intervention-badge"
                [ngClass]="getStatusClass(intervention)"
              >
                {{ getStatus(intervention) }}
              </span>
            </div>
            <div class="intervention-description">
              <p>
                {{
                  intervention.generatedDescription ||
                    intervention.description ||
                    'Aucune description'
                }}
              </p>
            </div>
            <div class="intervention-footer">
              <button
                pButton
                icon="pi pi-eye"
                label="Détails"
                class="p-button-outlined p-button-rounded p-button-sm"
                (click)="viewDetails(intervention)"
              ></button>
              <button
                pButton
                icon="pi pi-external-link"
                label="Ouvrir dans Éros"
                class="p-button-outlined p-button-rounded p-button-sm ml-1"
                (click)="openOnEros(intervention)"
              ></button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
